import { Injectable } from '@angular/core';
import { BcConfigService } from 'common/config/provider';
import { get as lodashGet } from 'lodash';

interface GenesysCloudFeatures {
  dxChat?: boolean;
  dxEmail?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class IfFeatureEnabledService {
  private readonly features: { gc: GenesysCloudFeatures } = { gc: {} };

  constructor(readonly configService: BcConfigService) {
    this.initFeatureState();
  }


  isFeatureEnabled(featurePath: string): boolean {
    const result = lodashGet(this.features, featurePath, null);
    if (result === null) {
      throw new Error(`There is no configured value for feature path "${featurePath}"`);
    }
    return !!result;
  }

  private initFeatureState(): void {
    // Actual Genesys related features will be fetched from a dedicated endpoint in a later story
    this.features.gc.dxChat = this.configService.current.features.genesysDxChat;
    this.features.gc.dxEmail = this.configService.current.features.genesysDxEmail;
  }
}
